export default {
  'SET_ACTIVITIES' (state, activities) {
    state.activities = activities
  },
  'SET_SELECTED_ACTIVITY' (state, activity) {
    state.selectedActivity = activity
  }
}
